"use client";
import React, { useMemo, useState } from "react";
import { GoogleMap, MarkerF, useLoadScript } from "@react-google-maps/api";

const Map = () => {
	const libraries = useMemo(() => [], []);

	const { isLoaded } = useLoadScript({
		googleMapsApiKey: "AIzaSyDdwms8toLIClSW2xsRs6DrtbdMrDKYdOM",
		libraries: libraries,
	});

	const [zoom, setZoom] = useState(5);

	const [center, setCenter] = useState({ lat: 55.8328158792, lng: 22.8862336114 });

	const mapCenter = useMemo(() => ({ lat: 55.8328158792, lng: 22.8862336114 }), []);
	const polandOffice = useMemo(() => ({ lat: 52.235031001611524, lng: 21.018129253558136 }), []);
	const estoniaOffice = useMemo(() => ({ lat: 59.430600756698695, lng: 24.754337969148676 }), []);

	const kyivOffice = useMemo(() => ({ lat: 50.445684, lng: 30.512705 }), []);

	const mapOptions = useMemo<google.maps.MapOptions>(
		() => ({
			styles: [
				{
					elementType: "geometry",
					stylers: [
						{
							color: "#f5f5f5",
						},
					],
				},
				{
					elementType: "labels.icon",
					stylers: [
						{
							visibility: "off",
						},
					],
				},
				{
					elementType: "labels.text.fill",
					stylers: [
						{
							color: "#616161",
						},
					],
				},
				{
					elementType: "labels.text.stroke",
					stylers: [
						{
							color: "#f5f5f5",
						},
					],
				},
				{
					featureType: "administrative.land_parcel",
					elementType: "labels.text.fill",
					stylers: [
						{
							color: "#bdbdbd",
						},
					],
				},
				{
					featureType: "poi",
					elementType: "geometry",
					stylers: [
						{
							color: "#eeeeee",
						},
					],
				},
				{
					featureType: "poi",
					elementType: "labels.text.fill",
					stylers: [
						{
							color: "#757575",
						},
					],
				},
				{
					featureType: "poi.park",
					elementType: "geometry",
					stylers: [
						{
							color: "#e5e5e5",
						},
					],
				},
				{
					featureType: "poi.park",
					elementType: "labels.text.fill",
					stylers: [
						{
							color: "#9e9e9e",
						},
					],
				},
				{
					featureType: "road",
					elementType: "geometry",
					stylers: [
						{
							color: "#ffffff",
						},
					],
				},
				{
					featureType: "road.arterial",
					elementType: "labels.text.fill",
					stylers: [
						{
							color: "#757575",
						},
					],
				},
				{
					featureType: "road.highway",
					elementType: "geometry",
					stylers: [
						{
							color: "#dadada",
						},
					],
				},
				{
					featureType: "road.highway",
					elementType: "labels.text.fill",
					stylers: [
						{
							color: "#616161",
						},
					],
				},
				{
					featureType: "road.local",
					elementType: "labels.text.fill",
					stylers: [
						{
							color: "#9e9e9e",
						},
					],
				},
				{
					featureType: "transit.line",
					elementType: "geometry",
					stylers: [
						{
							color: "#e5e5e5",
						},
					],
				},
				{
					featureType: "transit.station",
					elementType: "geometry",
					stylers: [
						{
							color: "#eeeeee",
						},
					],
				},
				{
					featureType: "water",
					elementType: "geometry",
					stylers: [
						{
							color: "#c9c9c9",
						},
					],
				},
				{
					featureType: "water",
					elementType: "labels.text.fill",
					stylers: [
						{
							color: "#9e9e9e",
						},
					],
				},
			],
			disableDefaultUI: true,
			clickableIcons: true,
			// scrollwheel: false,
		}),
		[]
	);

	if (!isLoaded) {
		return <p>Loading...</p>;
	}

	return (
		<GoogleMap
			options={mapOptions}
			zoom={zoom}
			// onZoomChanged={() => setZoom(zoom)}
			center={center}
			mapTypeId={google.maps.MapTypeId.ROADMAP}
			mapContainerStyle={{ width: "100%", height: "100%" }}
			onLoad={() => console.log("Map Component Loaded...")}
		>
			<MarkerF
				position={polandOffice}
				onClick={() => {
					if (zoom <= 10) {
						setZoom(10);
						setCenter(polandOffice);
					} else {
						setZoom(5);
						setCenter(mapCenter);
					}
				}}
			>
				{/*<InfoWindow>*/}
				{/*	<div>asd</div>*/}
				{/*</InfoWindow>*/}
			</MarkerF>

			<MarkerF
				position={estoniaOffice}
				onClick={() => {
					if (zoom <= 10) {
						setZoom(10);
						setCenter(estoniaOffice);
					} else {
						setZoom(5);
						setCenter(estoniaOffice);
					}
				}}
			/>

			<MarkerF
				position={kyivOffice}
				onClick={() => {
					if (zoom <= 10) {
						setZoom(10);
						setCenter(kyivOffice);
					} else {
						setZoom(5);
						setCenter(kyivOffice);
					}
				}}
			/>
		</GoogleMap>
	);
};

export default Map;
